import { render, staticRenderFns } from "./MeshFramePage.vue?vue&type=template&id=cfb1ae72"
import script from "./MeshFramePage.vue?vue&type=script&lang=js"
export * from "./MeshFramePage.vue?vue&type=script&lang=js"
import style0 from "./MeshFramePage.vue?vue&type=style&index=0&id=cfb1ae72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports